module.exports = __webpack_public_path__ + "img/trial1-2.293432b7.png";